var map = {
	"./Bad Man.mp3": 6229,
	"./Cobalt Theme Main.mp3": 7829,
	"./House Music.mp3": 89,
	"./Liminal Song.mp3": 6931,
	"./Note To.mp3": 2371,
	"./Space Song.mp3": 5717,
	"./Step Bravely.mp3": 6881,
	"./Voice 8 From Cascando.mp3": 2102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2654;